export default __webpack_public_path__ + "static/media/CheckOut.f6f77b7e.svg";